module.exports = __webpack_public_path__ + "static/media/bg_book-0.330b877a.png";